// Third-party brand marks, sourced from simple-icons so every glyph shares one
// 24-grid and we never hand-trace a trademark. Rendered through BrandMark.vue.
import {
  siApplepay,
  siBitcoin,
  siDiscord,
  siFacebook,
  siGooglepay,
  siInstagram,
  siKlarna,
  siMastercard,
  siPaypal,
  siReddit,
  siRevolut,
  siSteam,
  siStripe,
  siTelegram,
  siTiktok,
  siTwitch,
  siVisa,
  siX,
  siYoutube,
  type SimpleIcon,
} from 'simple-icons';

// Social platforms as named by the CMS (`GET /cms/social-links`). Keys are
// lower-cased before lookup; LinkedIn has no icon in simple-icons any more and
// falls back to a two-letter chip in the UI.
const SOCIAL: Record<string, SimpleIcon> = {
  discord: siDiscord,
  twitter: siX,
  x: siX,
  facebook: siFacebook,
  instagram: siInstagram,
  youtube: siYoutube,
  tiktok: siTiktok,
  telegram: siTelegram,
  // KeyzoStore's admin also offers these (CMS → Social links).
  reddit: siReddit,
  steam: siSteam,
  twitch: siTwitch,
};

/** Platforms the admin can pick, in picker order; LinkedIn has no glyph and shows as text. */
export const SOCIAL_PLATFORMS = ['Discord', 'X', 'Telegram', 'Instagram', 'YouTube', 'TikTok', 'Facebook', 'Reddit', 'Steam', 'Twitch', 'LinkedIn'];

export function socialIcon(platform: string): SimpleIcon | null {
  return SOCIAL[platform.toLowerCase()] ?? null;
}

// Payment rails as the admin names them (`GET /cms/payment-methods` slugs).
// Rails without a simple-icons glyph (bank transfer, Skrill, iDEAL, Sofort,
// Giropay, Paysafecard) render as a name chip; custom rails may carry their
// own `icon` URL.
const PAYMENT: Record<string, SimpleIcon> = {
  visa: siVisa,
  mastercard: siMastercard,
  paypal: siPaypal,
  crypto: siBitcoin,
  'apple-pay': siApplepay,
  'google-pay': siGooglepay,
  klarna: siKlarna,
  revolut: siRevolut,
  stripe: siStripe,
};

export function paymentIcon(slug: string): SimpleIcon | null {
  return PAYMENT[slug.toLowerCase()] ?? null;
}
